import { useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import { useAuth } from "../../../context/AuthContext";
import "../styles/LoginPage.css";
import { login } from "../service/authApi";
import Footer from "../../Dashboard/Footer";
import "../pages/Loginpage.css";


interface LoginPageProps {
  showFooter?: boolean;
}

const LoginPage = ({
  showFooter = true,
}: LoginPageProps) => {

    const navigate = useNavigate();

    const { login: saveLogin, } = useAuth();

    const [loading, setLoading] = useState(false);

    const [showPassword, setShowPassword] = useState(false);

    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

    };

    const handleSubmit = async (e: React.FormEvent) => {

        e.preventDefault();

        if (!formData.email.trim()) {

            toast.error("Email is required");

            return;
        }

        if (!formData.password.trim()) {

            toast.error("Password is required");

            return;
        }

        try {

            setLoading(true);

            const response =
                await login(formData);

            saveLogin(

                response.token,

                response.userID,

                response.email,

                response.role

            );

            toast.success("Login Successful");


            if (response.role === "Admin" || response.role === "SuperAdmin") {
                navigate("/admin")
            }
            else if (response.role === "Coordinator") {
                navigate("/coordinator")
            }
            else {
                navigate("/");
                console.log("Role: ", response.role)
            }


        }
        catch (error: any) {

            toast.error(
                error?.response?.data?.message ||
                "Invalid email or password"
            );

        }
        finally {

            setLoading(false);

        }

    };

    return (

        <> 
           <div className="login-page" >
    <Container fluid>
        <Row className="justify-content-center align-items-center login-row">
            <Col xl="4" lg="5" md="7" sm="9" xs="12">
                <Card className="login-card border-0 shadow-lg" style={{minHeight:"100px", borderRadius:"20px"}}>
                    <CardBody className="login-card-body">

                        <div className="text-center mb-4">
                            <img
                                className="brand-circle"
                                src={`${process.env.PUBLIC_URL}/assets/PriceWorth_Logo.WebP`}
                                alt="PriceWorth Logo"
                            />

                            <h2 className="price-logo">
                                Price<span>Worth</span>
                                <sup>™</sup>
                            </h2>

                            <p className="welcome-text">
                                Welcome back! Please login to continue.
                            </p>
                        </div>

                        <Form onSubmit={handleSubmit}>

                            <FormGroup floating>
                                <Input
                                    type="email"
                                    name="email"
                                    placeholder="Enter Email"
                                    value={formData.email}
                                    onChange={handleChange}
                                />
                                <Label>Email</Label>
                            </FormGroup>

                            <FormGroup floating className="mt-3">
                                <Input
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Enter Password"
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                                <Label>Password</Label>
                            </FormGroup>

                            <div className="login-options">
                                <FormGroup check>
                                    <Input
                                        type="checkbox"
                                        onChange={() =>
                                            setShowPassword(!showPassword)
                                        }
                                    />
                                    <Label check>
                                        Show Password
                                    </Label>
                                </FormGroup>

                                <Link to="/forgot-password">
                                    Forgot Password?
                                </Link>
                            </div>

                            <Button 
                                color="primary"
                                className="w-100 login-btn mt-3"
                                disabled={loading}
                            >
                                {loading ? <Spinner size="sm" /> : "Login"}
                            </Button>

                        </Form>

                        <div className="text-center mt-4">
                            Don't have an account?
                            <Link
                                to="/register"
                                className="ms-2"
                            >
                                Create Free Account
                            </Link>
                        </div>

                    </CardBody>
                </Card>
            </Col>
        </Row>
    </Container>
</div>

            {showFooter && <Footer />}

        </>

    );

};

export default LoginPage;